// Persistência do "já visto" das telas de boas-vindas dos módulos (CRM,
// Compliance, AAWZ Drive, ...). Marcado SÓ pelo checkbox "não mostrar novamente"
// (`toggleDismiss`) — nada grava automaticamente na 1ª visita. Enquanto o usuário
// não marcar, o redirect da raiz continua caindo no welcome a cada visita.
// Chaveada por profissional + módulo para não vazar entre profissionais no mesmo
// browser.
// Padrão defensivo de acesso ao localStorage (try/catch — storage corrompido ou
// indisponível é cenário esperado e tratado como ausência de dados).

import store from '@state/store'

// Identificador estável do profissional logado. Usa o mesmo discriminador
// (id_interno) já adotado pelo padrão de search-clients no localStorage; cai
// para id/email e, por fim, 'anon' quando o usuário ainda não está disponível.
const getProfessionalId = () => {
  const user = store.getters['user/currentUser'] || {}
  return user.id_interno || user.id || user.email || 'anon'
}

export const welcomeDismissedKey = (moduleKey) =>
  `aawz_welcome_dismissed_${moduleKey}_${getProfessionalId()}`

export const isWelcomeDismissed = (moduleKey) => {
  if (!moduleKey) return false
  return localStorage.getItem(welcomeDismissedKey(moduleKey)) === 'true'
}

export const setWelcomeDismissed = (moduleKey, value = true) => {
  if (!moduleKey) return
  localStorage.setItem(welcomeDismissedKey(moduleKey), value ? 'true' : 'false')
}
